module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/sniff-error-471.3593b8f270b0d891.png"+" 471w",
        images: [{path: "https://static.sniffspot.com/packs/img/sniff-error-471.3593b8f270b0d891.png",width: 471,height: 588}],
        src: "https://static.sniffspot.com/packs/img/sniff-error-471.3593b8f270b0d891.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/sniff-error-471.3593b8f270b0d891.png"},
        
        width: 471,
        height: 588
      }